import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=1190bafa&"
import script from "./ReviewCard.vue?vue&type=script&lang=js&"
export * from "./ReviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports